module.exports = __webpack_public_path__ + "img/CardImageSurvey11.26c66c87.png";